<template>
  <div class="pp">
    <div class="two">
      <div style="display: none" ref="rightScroll" class="pic">
        <div>
          <span class="span1">科研创新</span>
          <span class="span2">Scientific research innovation</span>
          <div class="div1" ></div>
          <div class="div2" >{{n.title}}</div>
          <div class="div22" v-html="delHtmlTag(n.message)" >{{n.message}}</div>
          <!--<div class="div22">近日，大伟嘉股份荣获北京市专精特新“小巨人”企业称号，北京市经济和信息化局授予大伟嘉专精特新“小巨人”企业证书，这是继开封伟嘉生物技术有限公司荣获河南省专精特新中小企业认定后，大伟嘉集团增添的又一殊荣。</div>-->
          <button>
            <a href="#/ke">
              <span class="span3">了解更多</span>
              <span class="span4" >→</span>
            </a>
          </button>
          <div class="ll">
          <div class="div3">Scientific</div>
          <div class="div4">research</div>
          <div class="div5">innovation</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getWapFirst} from '@/api/index';
  import "animate.css";

  export default {
    data() {
      return {
        n:[],
      };
    },
    name: "Two",
    methods: {

      // if(str!= null){
      //   return str.replace(/<[^>]+>/g,"");
      // }
      delHtmlTag(str) {
        // console.log(str)
        // if (str != null || str == undefined  ) {
        //   console.log(str.replace(/<[^>]+>/g, ""))
        //   return str.replace(/<[^>]+>/g, "");
        if (str != null || str == undefined  ) {
          let estr = str
              // .replace(/<[^>]+>/g, "")
                  .replace(/&lt;/g,"<")
                  .replace(/&gt;/g,">")
                  .replace(/&amp;/g, "")
                  .replace(/&nbsp;/g,"")
                  .replace(/nbsp;/g,"")
                  .replace(/&quot;/g, '"')
          ;
          // console.log(estr)
          return estr

        }else {
          // console.log(222);
        }

      },
    }
    ,
    mounted() {

      getWapFirst().then((res)=>{
        console.log(res);
        return res;
      })
          .then((res)=>{
            // 获取响应数据
            let n = res.data[0];
            this.n = n;
            // console.log(nei.content);
          })


      window.addEventListener("scroll",() => {
        //变量t是滚动条滚动时，距离顶部的距离
        var a = document.documentElement.clientHeight;

        var t = document.documentElement.scrollTop || document.body.scrollTop;
        //当滚动到距离顶部200px时，返回顶部的锚点显示

        if (t+20  >4* a && t+20 < 5 * a) {
          // console.log(1111)
          this.$refs.rightScroll.style.display = "block";
          this.$refs.rightScroll.className =
              "animate__animated animate__bounce animate__bounceInLeft pic";
        } else {
          this.$refs.rightScroll.style.display = "none";
          this.$refs.rightScroll.className = "";

        }
      })
    }
  };
</script>

<style lang="less" scoped>
  .pp{
    width: 100%;
    height: 93vh;
    transform:translate3d(0,0,0);
    overflow:hidden;

  }
  .animate__animated.animate__bounce {
    --animate-duration: 1.5s;
    transform:translate3d(0,0,0);
  }

  .two {
    display: flex;
    width: 100%;
    background-image:url("../../../assets/22.png");
    background-size:100% 93vh;
    .pic {
      flex: 10;
      height: 93vh;
      overflow:hidden;
    }
    .span1{
      position: absolute;
      font-size: 5vw;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 400;
      color: #ffffff;
      padding-left: 5vw;
      padding-top: 3vh;
    }
    .span2{
      position: absolute;
      font-size: 3.7vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 300;
      color: #ffffff;
      padding-left: 27vw;
      padding-top: 3.8vh;
    }
    .div1{
      width: 26.6667vw;
      height: 0.25vh;
      background: #d7000f;
      position: absolute;
      margin-top: 6.5vh;
      margin-left: 5vw;
    }
    .div2{
      font-size: 5vw;
      font-family: PingFang SC, PingFang SC-Light;
      font-weight: 300;
      color: #ffffff;
      padding-top: 29vh;
      text-align: center;
      margin-bottom: 15vw;
    }
    .div22{
      font-size: 3.6vw;
      width: 90vw;
      font-family: PingFang SC, PingFang SC-Light;
      line-height: 4.7vw;
      font-weight: 400;
      color: #ffffff;
      padding-left: 5vw;
      margin-bottom: 20vw;
    }
    button{
      width: 28vw;
      height: 4vh;
      background: #d7000f;
      border-radius: 1vw;
      display: block;
      margin: 0 auto!important;
    }
    .span3{
      font-size: 3.5vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #ffffff;
    }
    .span4{
      font-size: 3.5vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #ffffff;
    }
    .ll{
      margin-left: 36vw;
    }
    .div3{
      font-size: 3.5vw;
      font-weight: bold;
      padding-top: 6.0524vh;
      color: #ffffff;
    }
    .div4{
      font-size: 3.5vw;
      padding-top: 1.2vh;
      color: #ffffff;
    }
    .div5{
      font-size: 3.5vw;
      padding-top: 1.2vh;
      color: #ffffff;
    }


  }
</style>
